// 视频质量等级
export const VIDEO_LEVEL = {
  NORMAL: 0, // 原画
  MID: 1, // 中级画质
  LOW: 2 // 低级画质
}
// 设备角色
export const DEVICE_ROLE = {
  TEACHER: 1, // 老师机位
  STUDENT: 2 // 学生机位
}

